import React, { useState, useEffect } from 'react';
import { Menu, X, Zap } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-md py-3 shadow-lg' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">
          <a href="#" className="flex items-center gap-2">
            <Zap className="h-8 w-8 text-teal-400" />
            <span className="text-xl font-bold tracking-tight">ChatSiva</span>
          </a>
          
          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">Features</a>
            <a href="#workflows" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">Workflows</a>
            <a href="#" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">Pricing</a>
            <a href="#" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">About</a>
            <a 
              href="#cta" 
              className="px-4 py-2 bg-gradient-to-r from-teal-400 to-cyan-500 text-white rounded-lg text-sm font-medium hover:shadow-lg hover:from-teal-500 hover:to-cyan-600 transition-all"
            >
              Get Started
            </a>
          </nav>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden text-white p-2" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-slate-900 shadow-xl p-4 border-t border-slate-800 animate-fadeIn">
          <nav className="flex flex-col gap-4 px-2">
            <a 
              href="#features" 
              className="py-2 text-slate-300 hover:text-white transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </a>
            <a 
              href="#workflows" 
              className="py-2 text-slate-300 hover:text-white transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Workflows
            </a>
            <a 
              href="#" 
              className="py-2 text-slate-300 hover:text-white transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </a>
            <a 
              href="#" 
              className="py-2 text-slate-300 hover:text-white transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </a>
            <a 
              href="#cta" 
              className="mt-2 px-4 py-3 bg-gradient-to-r from-teal-400 to-cyan-500 text-white rounded-lg font-medium hover:shadow-lg hover:from-teal-500 hover:to-cyan-600 transition-all text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Get Started
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;